import {
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import honorArrow from '@/assets/img/tmp/honors-club/honors_arrow@2x.png';
import honorsclub1 from '@/assets/img/tmp/honors-club/honorsclub_obj1@2x.png';
import honorsclub2 from '@/assets/img/tmp/honors-club/honorsclub_obj2@2x.png';
import honorsclub3 from '@/assets/img/tmp/honors-club/honorsclub_obj3@2x.png';
import honorsclub4 from '@/assets/img/tmp/honors-club/honorsclub_obj4@2x.png';
import honorsclub5 from '@/assets/img/tmp/honors-club/honorsclub_obj5@2x.png';
import honorsclub6 from '@/assets/img/tmp/honors-club/honorsclub_obj6@2x.png';
import honorJoin1 from '@/assets/img/tmp/honors-club/join_honors_obj01@2x.png';
import honorJoin2 from '@/assets/img/tmp/honors-club/join_honors_obj02@2x.png';
import honorJoin3 from '@/assets/img/tmp/honors-club/join_honors_obj03@2x.png';
import honorJoin4 from '@/assets/img/tmp/honors-club/join_honors_obj04@2x.png';
import honorJoin5 from '@/assets/img/tmp/honors-club/join_honors_obj05@2x.png';
import People1 from '@/assets/img/tmp/honors-club/people_img1.png';
import People10 from '@/assets/img/tmp/honors-club/people_img10.png';
import People11 from '@/assets/img/tmp/honors-club/people_img11.png';
import People12 from '@/assets/img/tmp/honors-club/people_img12.png';
import People13 from '@/assets/img/tmp/honors-club/people_img13.png';
import People14 from '@/assets/img/tmp/honors-club/people_img14.png';
import People15 from '@/assets/img/tmp/honors-club/people_img15.png';
import People16 from '@/assets/img/tmp/honors-club/people_img16.png';
import People17 from '@/assets/img/tmp/honors-club/people_img17.png';
import People18 from '@/assets/img/tmp/honors-club/people_img18.png';
import People19 from '@/assets/img/tmp/honors-club/people_img19.png';
import People2 from '@/assets/img/tmp/honors-club/people_img2.png';
import People20 from '@/assets/img/tmp/honors-club/people_img20.png';
import People21 from '@/assets/img/tmp/honors-club/people_img21.png';
import People22 from '@/assets/img/tmp/honors-club/people_img22.png';
import People23 from '@/assets/img/tmp/honors-club/people_img23.png';
import People24 from '@/assets/img/tmp/honors-club/people_img24.png';
import People25 from '@/assets/img/tmp/honors-club/people_img25.png';
import People26 from '@/assets/img/tmp/honors-club/people_img26.png';
import People27 from '@/assets/img/tmp/honors-club/people_img27.png';
import People28 from '@/assets/img/tmp/honors-club/people_img28.png';
import People29 from '@/assets/img/tmp/honors-club/people_img29.png';
import People30 from '@/assets/img/tmp/honors-club/people_img30.png';
import People31 from '@/assets/img/tmp/honors-club/people_img31.png';
import People3 from '@/assets/img/tmp/honors-club/people_img3@2x.png';
import People4 from '@/assets/img/tmp/honors-club/people_img4@2x.png';
import People5 from '@/assets/img/tmp/honors-club/people_img5@2x.png';
import People6 from '@/assets/img/tmp/honors-club/people_img6@2x.png';
import People7 from '@/assets/img/tmp/honors-club/people_img7.png';
import People8 from '@/assets/img/tmp/honors-club/people_img8.png';
import People9 from '@/assets/img/tmp/honors-club/people_img9.png';
import PeoplePop1 from '@/assets/img/tmp/honors-club/people_pop1.png';
import PeoplePop10 from '@/assets/img/tmp/honors-club/people_pop10.png';
import PeoplePop11 from '@/assets/img/tmp/honors-club/people_pop11.png';
import PeoplePop12 from '@/assets/img/tmp/honors-club/people_pop12.png';
import PeoplePop13 from '@/assets/img/tmp/honors-club/people_pop13.png';
import PeoplePop15 from '@/assets/img/tmp/honors-club/people_pop15.png';
import PeoplePop16 from '@/assets/img/tmp/honors-club/people_pop16.png';
import PeoplePop18 from '@/assets/img/tmp/honors-club/people_pop18.png';
import PeoplePop19 from '@/assets/img/tmp/honors-club/people_pop19.png';
import PeoplePop2 from '@/assets/img/tmp/honors-club/people_pop2.png';
import PeoplePop20 from '@/assets/img/tmp/honors-club/people_pop20.png';
import PeoplePop21 from '@/assets/img/tmp/honors-club/people_pop21.png';
import PeoplePop23 from '@/assets/img/tmp/honors-club/people_pop23.png';
import PeoplePop24 from '@/assets/img/tmp/honors-club/people_pop24.png';
import PeoplePop25 from '@/assets/img/tmp/honors-club/people_pop25.png';
import PeoplePop26 from '@/assets/img/tmp/honors-club/people_pop26.png';
import PeoplePop27 from '@/assets/img/tmp/honors-club/people_pop27.png';
import PeoplePop28 from '@/assets/img/tmp/honors-club/people_pop28.png';
import PeoplePop29 from '@/assets/img/tmp/honors-club/people_pop29.png';
import PeoplePop30 from '@/assets/img/tmp/honors-club/people_pop30.png';
import PeoplePop31 from '@/assets/img/tmp/honors-club/people_pop31.png';
import PeoplePop3 from '@/assets/img/tmp/honors-club/people_pop3.png';
import PeoplePop4 from '@/assets/img/tmp/honors-club/people_pop4.png';
import PeoplePop5 from '@/assets/img/tmp/honors-club/people_pop5.png';
import PeoplePop6 from '@/assets/img/tmp/honors-club/people_pop6.png';
import PeoplePop7 from '@/assets/img/tmp/honors-club/people_pop7.png';
import PeoplePop8 from '@/assets/img/tmp/honors-club/people_pop8.png';
import PeoplePop9 from '@/assets/img/tmp/honors-club/people_pop9.png';
import TopImg from '@/assets/img/tmp/honors-club/top_img@2x.png';
import TopImgM from '@/assets/img/tmp/honors-club/top_imgM@2x.png';
import Button, { BtnClose } from '@/components/Button';
import { CampaignData } from '@/components/Card/CampaignCard';
import HonorsInquiryCard from '@/components/Card/HonorsInquiryCard';
import RelativeBoardCard from '@/components/Card/RelativeBoardCard';
import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import { PopCcontainer, PopupTitle } from '@/components/Css/Pop';
import FormGroup from '@/components/Form/FormGroup';
import Image from '@/components/Image';
import Modal from '@/components/Modal';
import PageComponent from '@/components/PageComponent';
import { ProcessList } from '@/components/ProcessList';
import Section, { SectionNews } from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import { NotiBox, NotiItem, NotiList } from '@/components/Text/TextNoti';
import { Tit, H4 } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
// import HonorsClubTab from '@/pages/involve/individual/honors-club';
import InternationalCouncilTab from '@/pages/involve/individual/international-council';
import {
  HonorsClubData,
  HonorsClubTabProps,
} from '@page-blocks/involve/individual/HonorsClubInterface';
import { useLocation } from '@reach/router';
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import LinkSafe from '@/components/LinkSafe';

const peopleData = [
  // {
  //   id: 1,
  //   img: People1,
  //   popImg: PeoplePop1,
  //   pop: [
  //     {
  //       dec: `아너스클럽 가입`,
  //     },
  //     {
  //       dec: `2016년 말라위 현장 방문`,
  //     },
  //   ],
  //   desc: [
  //     {
  //       id: 1,
  //       dec: `유니세프한국위원회 친선대사 <br />배우 안성기`,
  //     },
  //   ],
  // },
  {
    id: 1,
    img: People1,
    popImg: PeoplePop1,
    desc: [
      {
        id: 1,
        dec: `유니세프한국위원회 친선대사 <br />배우 안성기`,
      },
    ],
  },
  {
    id: 2,
    img: People10,
    popImg: PeoplePop10,
    desc: [
      {
        id: 2,
        dec: `유니세프한국위원회 친선대사 <br />배우 김혜수`,
      },
    ],
  },
  {
    id: 3,
    img: People2,
    popImg: PeoplePop2,
    desc: [
      {
        id: 3,
        dec: `유니세프 국제친선대사 <br />김연아 前국가대표`,
      },
    ],
  },
  {
    id: 4,
    img: People7,
    popImg: PeoplePop7,
    desc: [
      {
        id: 4,
        dec: `유니세프동아시아태평양지역 친선대사 <br />배우 최시원`,
      },
    ],
  },
  {
    id: 5,
    img: People3,
    popImg: PeoplePop3,
    desc: [
      {
        id: 5,
        dec: `유니세프한국위원회 친선대사 <br />배우 원빈`,
      },
    ],
  },
  {
    id: 6,
    img: People5,
    popImg: PeoplePop5,
    desc: [
      {
        id: 6,
        dec: `아모레퍼시픽 그룹 <br />서경배 회장`,
      },
    ],
  },
  {
    id: 7,
    img: People12,
    popImg: PeoplePop12,
    desc: [
      {
        id: 7,
        dec: `배우 설경구`,
      },
    ],
  },
  {
    id: 8,
    img: People14,
    popImg: PeoplePop12,
    desc: [
      {
        id: 8,
        dec: `배우 송윤아`,
      },
    ],
  },
  {
    id: 9,
    img: People4,
    popImg: PeoplePop4,
    desc: [
      {
        id: 9,
        dec: `배우 이민호`,
      },
    ],
  },
  {
    id: 10,
    img: People15,
    popImg: PeoplePop15,
    desc: [
      {
        id: 10,
        dec: `배우 장근석`,
      },
    ],
  },
  {
    id: 11,
    img: People13,
    popImg: PeoplePop13,
    desc: [
      {
        id: 11,
        dec: `배우 송중기`,
      },
    ],
  },
  {
    id: 12,
    img: People6,
    popImg: PeoplePop6,
    desc: [
      {
        id: 12,
        dec: `배우 이혜리`,
      },
    ],
  },
  {
    id: 18,
    img: People18,
    popImg: PeoplePop18,
    desc: [
      {
        id: 18,
        dec: `화가 김병종`,
      },
    ],
  },
  {
    id: 13,
    img: People8,
    popImg: PeoplePop8,
    desc: [
      {
        id: 13,
        dec: `배우 한지민`,
      },
    ],
  },
  {
    id: 14,
    img: People11,
    popImg: PeoplePop11,
    desc: [
      {
        id: 14,
        dec: `배우 박서준`,
      },
    ],
  },
  {
    id: 15,
    img: People9,
    popImg: PeoplePop9,
    desc: [
      {
        id: 15,
        dec: `배우 수지`,
      },
    ],
  },
  {
    id: 16,
    img: People16,
    popImg: PeoplePop16,
    desc: [
      {
        id: 16,
        dec: `배우 지창욱`,
      },
    ],
  },
  {
    id: 17,
    img: People17,
    desc: [
      {
        id: 17,
        dec: `축구선수 김민재`,
      },
    ],
  },
  {
    id: 19,
    img: People19,
    popImg: PeoplePop19,
    desc: [
      {
        id: 19,
        dec: `한문학자 故 이대봉`,
      },
    ],
  },
  {
    id: 20,
    img: People20,
    popImg: PeoplePop20,
    desc: [
      {
        id: 20,
        dec: `가수 NCT 도영`,
      },
    ],
  },
  {
    id: 21,
    img: People21,
    popImg: PeoplePop21,
    desc: [
      {
        id: 21,
        dec: `동국제강그룹 장세욱 부회장`,
      },
    ],
  },
  {
    id: 22,
    img: People22,
    desc: [
      {
        id: 22,
        dec: `코리아결제시스템(주) 박형석 회장`,
      },
    ],
  },
  {
    id: 23,
    img: People23,
    popImg: PeoplePop23,
    desc: [
      {
        id: 23,
        dec: `가정의학과 전문의 장영민`,
      },
    ],
  },
  {
    id: 24,
    img: People24,
    popImg: PeoplePop24,
    desc: [
      {
        id: 24,
        dec: `핑크원더 대표 최금실`,
      },
    ],
  },
  {
    id: 25,
    img: People25,
    popImg: PeoplePop25,
    desc: [
      {
        id: 25,
        dec: `서울대학교 명예교수 모수미`,
      },
    ],
  },
  {
    id: 26,
    img: People26,
    popImg: PeoplePop26,
    desc: [
      {
        id: 26,
        dec: `유니세프한국위원회 친선대사 <br />가수 스트레이 키즈 필릭스`,
      },
    ],
  },
  {
    id: 27,
    img: People27,
    popImg: PeoplePop27,
    desc: [
      {
        id: 27,
        dec: `가수 스트레이 키즈 방찬`,
      },
    ],
  },
  {
    id: 28,
    img: People28,
    popImg: PeoplePop28,
    desc: [
      {
        id: 28,
        dec: `前 대검찰청 사무국장 양희천`,
      },
    ],
  },
  {
    id: 29,
    img: People29,
    popImg: PeoplePop29,
    desc: [
      {
        id: 29,
        dec: `서청길`,
      },
    ],
  },
  {
    id: 30,
    img: People30,
    popImg: PeoplePop30,
    desc: [
      {
        id: 30,
        dec: `(주)원온 대표이사 윤재연`,
      },
    ],
  },
  {
    id: 31,
    img: People31,
    popImg: PeoplePop31,
    desc: [
      {
        id: 31,
        dec: `(주)뷰메드 대표이사 서정길`,
      },
    ],
  },
];

/* 가입방법 */
const joinProcess = [
  {
    id: 1,
    img: honorJoin1,
    title: `가입문의`,
    link: null,
  },
  {
    id: 2,
    img: honorJoin2,
    title: `맞춤형 사업 안내`,
  },
  {
    id: 3,
    img: honorJoin3,
    title: `후원확정`,
  },
  {
    id: 4,
    img: honorJoin4,
    title: `멤버십 서비스`,
  },
  {
    id: 5,
    img: honorJoin5,
    title: `결과보고`,
  },
];

const honorsclub = [
  {
    id: 1,
    img: honorsclub1,
    title: `맞춤형 상담 및 <br class="br_m" />후원`,
    desc: [
      {
        id: 11,
        dec: `도움이 필요한 국가와 사업을 지정하시면
        그에 맞는 후원 사업 제안서를 드립니다.`,
      },
    ],
  },
  {
    id: 2,
    img: honorsclub2,
    title: `기부금 영수증 발급<br class="br_m" />(세액공제)`,
    desc: [
      {
        id: 21,
        dec: `유니세프한국위원회는 지정기부금 단체로, 세액 공제 혜택을 받으실 수 있습니다.`,
      },
    ],
  },
  {
    id: 3,
    img: honorsclub3,
    title: `예우 공간의 <br class="br_m" />주인공`,
    desc: [
      {
        id: 31,
        dec: `유니세프한국위원회 사옥의 후원자
        예우공간에 후원 스토리를 게시해<br />
        회원님의 뜻을 널리 알립니다.`,
      },
    ],
  },
  {
    id: 4,
    img: honorsclub4,
    title: `유니세프 사업 현장 <br class="br_m" />방문`,
    desc: [
      {
        id: 41,
        dec: `내 후원금이 쓰이는 현장을 찾아 직접
        어린이들을 만나고, 그로 인한 변화를 눈으로
        확인하실 수 있습니다.`,
      },
    ],
  },
  {
    id: 5,
    img: honorsclub5,
    title: `아너스클럽 회원 간 <br class="br_m" />네트워크`,
    desc: [
      {
        id: 51,
        dec: `같은 가치를 공유하는 분들과의<br class="br_pc" />
        만남을 통해 보람과 기쁨을<br class="br_pc" />
        얻을 수 있습니다.`,
      },
    ],
  },
  {
    id: 6,
    img: honorsclub6,
    title: `상세한 <br class="br_m" />결과 보고`,
    desc: [
      {
        id: 61,
        dec: `수혜국가 유니세프 담당 직원이<br class="br_pc" />
        후원 내역을 상세히 보고 드립니다.`,
      },
    ],
  },
];

const SectionTop = styled(Section)`
  ${SectionHeader} {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;

    .col-dec {
      width: 59%;
      padding-right: 15px;

      p {
        margin-top: 32px;
      }
    }

    ${breakpoint(`tablet`)} {
      flex-wrap: wrap;

      .col-dec {
        width: 100%;
        margin-bottom: 32px;
      }

      .col-img {
        width: 100%;
        text-align: center;

        picture,
        img {
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
`;

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `고액후원팀`,
    tel: `02-721-5150~3`,
    email: `major@unicef.or.kr`,
  },
];

const SectionJoin = styled(Section)`
  ol {
    ${breakpoint(`tablet`)} {
      row-gap: 50px;
    }
    .list-item {
      width: 20%;

      ${breakpoint(`tablet`)} {
        width: 50%;
        margin-bottom: 0;
        padding: 0 58px 0 10px;

        &:nth-child(2) {
          dt {
            &::after {
              display: block;
            }
          }
        }
      }
    }
    .process-link {
      display: block;
    }

    &.arrow {
      dt {
        &::after {
          width: 40px;
          height: 12px;
          background-image: url(${honorArrow});
          right: -16px;

          ${breakpoint(`tablet`)} {
            right: -58px;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  ${NotiBox} {
    padding: 30px;
    margin-top: 64px;
    margin-bottom: 0;
    ${NotiItem} {
      font-weight: 400;
    }
    ${breakpoint(`tablet`)} {
      width: calc(100% + 40px);
      margin-top: 32px;
      margin-left: -20px;
    }
  }
`;

const SectionHonorsClub = styled(Section)`
  background: #e2f0f6;
  padding: 120px 0;
  .br_m {
    display: none;
  }

  ${SectionHeader} {
    p {
      margin-top: 8px;
    }
  }

  ol {
    row-gap: 64px;
    .list-item {
      width: 33.33%;

      dt {
        padding: 0;

        .img-wrap {
          height: 80px;

          .img-box {
            height: 100%;
            background-size: contain;
            padding-top: 80px;
          }
        }
      }

      dd {
        max-width: 270px;
        margin: 0 auto;
      }

      ${breakpoint(`tablet`)} {
        dd {
          max-width: 200px;
        }
      }
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 60px 0;
    .br_m {
      display: block;
    }
    .br_pc {
      display: none;
    }
    ol {
      row-gap: 44px;
      .list-item {
        width: 50%;
        padding: 0 12px;
        margin-bottom: 0;

        dt {
          .img-wrap {
            height: 40px;
            .img-box {
              padding-top: 40px;
            }
          }
        }
      }
    }
  }
`;

const SwiperPeople = styled(SwiperBasic)`
  &.pc {
    visibility: visible;
    .swiper-container {
      padding-top: 96px;
    }
  }
  &.mob {
    visibility: hidden;
    height: 0;
    padding: 0;
    .swiper-slide {
      height: auto;
      .people {
        height: 100%;
        .process-ol {
          height: 100%;
        }
      }
    }
  }
  ${breakpoint(`tablet`)} {
    &.pc {
      visibility: hidden;
      height: 0;
    }
    &.mob {
      visibility: visible;
      height: auto;
      overflow: hidden;
    }
  }
`;
const SectionWidth = styled(Section)`
  .header-dec {
    margin-top: 0;
  }
  ${SectionHeader} {
    padding-bottom: 0;
  }

  .process-ol {
    margin: 0;
    height: auto !important;
    .list-item {
      width: 33.33%;
      min-height: 332px;
      padding: 0 15px;
      margin-bottom: 64px;
      transition: transform 0.5s ease;

      &:nth-child(n + 7):nth-child(-n + 9) {
        margin-bottom: 0;
      }
      &:hover {
        transform: scale(1.05);
      }

      dt {
        padding: 0;
        .img-wrap {
          max-width: 256px;
        }
      }

      .dec-ul {
        margin-top: 24px;
      }
    }

    ${breakpoint(`tablet`)} {
      .list-item {
        width: 50%;

        &:nth-child(n + 5):nth-child(-n + 6) {
          margin-bottom: 0;
        }
        &:hover {
          transform: scale(1);
        }
      }
    }
  }
  .scroll-only .swiper-scrollbar {
    width: auto;
    left: 16px;
    margin-left: 0;
    transform: translate(0, 0);
    right: 218px;
  }

  ${breakpoint(`tablet`)} {
    .scroll-only .swiper-scrollbar {
      width: calc(100% - 40px);
      left: 20px;
    }
    ${SectionHeader} {
      padding-bottom: 72px;
    }
    .header-dec {
      margin-top: 32px;
    }
  }
  ${breakpoint(`mobile`)} {
    ${Container} {
      padding: 0;
      overflow: hidden;
    }
    ${SectionHeader} {
      padding: 0 20px 72px;
    }
    .process-ol {
      .list-item {
        min-height: auto;
        margin-bottom: 48px;
      }
    }
    .header-dec {
      padding: 0 20px;
    }
  }
`;

const ContactPopup = styled.div``;
const PopupContent = styled.div`
  &.people-pop-content {
    padding: 35px 109px 96px;

    .content-title {
      padding-left: 24px;
      margin-bottom: 60px;
    }
    ${Tit} {
      display: block;
      margin-bottom: 20px;
    }

    ${breakpoint(`mobile`)} {
      padding: 25px 0;
      .content-title {
        padding-left: 0;
        margin-bottom: 30px;
      }
      ${Tit} {
        margin-bottom: 10px;
      }
    }

    p {
      position: relative;
      padding-left: 23px;
      font-size: 24px;
      line-height: 1.67;

      &::before {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        background: #1cabe2;
        position: absolute;
        top: 16px;
        left: 1px;
        transform: rotate(45deg);
      }
      ${breakpoint(`tablet`)} {
        font-size: 2.06vw;
        &::before {
          width: 0.86vw;
          height: 0.86vw;
          top: 1.37vw;
        }
      }
      ${breakpoint(`tablet`)} {
        font-size: 14px;
        line-height: 2;
        padding-left: 15px;
        &::before {
          width: 5px;
          height: 5px;
          top: 12px;
        }
      }
    }
  }

  &.inquiry-pop-content {
    max-width: 600px;
    margin: 0 auto;
    padding: 24px 0 50px;

    ${H4} {
      margin-bottom: 22px;
    }
    textarea {
      height: 140px;
    }
    .btn-wrap {
      margin-top: 34px;
      .btn {
        width: 100%;
      }
    }
  }
`;
const FloatingBtn = styled(Button)`
  position: fixed;
  bottom: 50px;
  right: 100px;
  z-index: 100;
  width: 150px;
  background: #1cabe2;
  color: #fff;
  font-size: 18px;

  ${breakpoint(`tablet`)} {
    right: 20px;
  }
  ${breakpoint(`mobile`)} {
    .br_pc {
      display: none;
    }
    width: calc(100% - 40px);
    bottom: 30px;
    font-size: 16px;
  }
`;

const brochureData = [
  {
    id: 1,
    title: `고액후원팀 소개서`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ob25vdXJzLWNsdWI=&dispFileNm=Philanthropy-Legacy.pdf&svrFileNm=Philanthropy-Legacy.pdf`,
  },
  {
    id: 2,
    title: `아너스클럽`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ob25vdXJzLWNsdWI=&dispFileNm=250513_honours-club-brochure.pdf&svrFileNm=250513_honours-club-brochure.pdf`,
  },
];

const BrochureWrap = styled.div`
  padding-bottom: 120px;

  h4 {
    margin-bottom: 54px;
  }
  .btn-wrap {
    display: flex;
    gap: 30px;

    .col {
      flex: 1;
    }
  }
  ${breakpoint(`tablet`)} {
    padding-bottom: 60px;

    h4 {
      margin-bottom: 32px;
    }
    .btn-wrap {
      flex-direction: column;
      gap: 16px;
    }
  }

  ${Button} {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    ${breakpoint(`mobile`)} {
      padding: 15px 24px;
    }
  }
`;

const SectionInquiry = styled(Section)`
  background: #f8f9fa;

  .form-container {
    max-width: 736px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;

    ${FormGroup} {
      width: 50%;
      padding: 0 16px;
      margin-bottom: 24px;
      &.full {
        width: 100%;
      }
    }

    .chk-label {
      font-size: 14px;
    }
  }

  .btn-wrap {
    margin-top: 78px;
    text-align: center;

    .btn {
      width: 100%;
      max-width: 350px;
    }
  }

  ${breakpoint(640)} {
    ${SectionHeader} {
      padding-bottom: 36px;
    }
    .form-container {
      max-width: auto;
      width: 100%;
      display: block;
      ${FormGroup} {
        width: 100%;
        padding: 0;
        margin-bottom: 16px;

        textarea {
          height: 140px;
        }
      }
    }
    .btn-wrap {
      margin-top: 40px;
    }
  }

  .clear {
    display: block;
    width: 100%;
    height: 0;
    clear: both;
    visibility: hidden;
  }
`;

const SectionContact = styled(Section)`
  padding-bottom: 240px !important;

  ${breakpoint(`tablet`)} {
    padding-bottom: 120px !important;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  position: relative;

  .video-wrap {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    /* padding-top: 66.69%; */
    padding-top: 56.25%;
    position: relative;
  }
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  ${breakpoint(`tablet`)} {
    &::before {
      width: auto;
      height: 0;
      padding-top: 69.44%;
      left: -20px;
      right: -20px;
      transform: translate(0, 0);
    }
  }
`;
const honorTab = [
  {
    idx: 0,
    title: `아너스클럽 <em>(Honours Club)</em>`,
  },
  {
    idx: 1,
    title: `인터내셔널 카운슬 <em>(International Council)</em>`,
  },
];
const SectionTab = styled.div`
  height: 80px;
  border-bottom: 3px solid #c6c6c6;
  ${breakpoint(`mobile`)} {
    ${Container} {
      padding: 0;
    }
  }
`;
const TabButton = styled.li<{ active: boolean }>`
  cursor: pointer;
  width: 50%;
  height: 80px;
  line-height: 1.25;
  display: inline-flex;
  align-items: center;
  border-bottom: 3px solid #c6c6c6;
  border-color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  margin: 0;
  &:hover {
    border-color: #1cabe2;
    color: #1cabe2;
  }
  span {
    display: block;
    width: 100%;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    em {
      font-weight: 700;
    }
  }
  ${breakpoint(`mobile`)} {
    span {
      font-size: 16px;
      em {
        display: block;
      }
    }
  }
`;

const HonorsClub: React.FC<HonorsClubTabProps> = ({
  location,
  hashScroll,
  hashScrollCallback,
}) => {
  const [thumbs, setThumbs] = useState<CampaignData[]>([]);
  const [isPeopleModalOpen, setIsPeopleModalOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [showFloatingBtn, setShowFloatingBtn] = useState(true);
  const [hasClosedPopup, setHasClosedPopup] = useState(false); // 팝업을 닫은 적이 있는지 기억
  const sectionRef = useRef(null); // SectionContact 감지
  const isInSectionRef = useRef(false); // 섹션 안/밖 상태 기억
  // const location = useLocation();
  const { pathname, hash } = useMemo(() => location, [location]);
  const targetRef = useRef<HTMLLIElement | null>(null);
  const activeTab = useMemo(() => {
    if (location.pathname.includes('international')) return 1;
    return 0;
  }, [location.pathname]);
  // const [hashScroll, setHashScroll] = useState(false);

  // 🎯 클릭 시 People 모달 오픈
  const handleClick = (person) => {
    if (person.popImg) {
      setSelectedPerson(person);
      setIsPeopleModalOpen(true);
    }
  };

  // 🎯 함께하는 분들 진입 시 Inquiry 모달 오픈
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        isInSectionRef.current = entry.isIntersecting;

        if (entry.isIntersecting) {
          if (!hasClosedPopup) {
            // 팝업을 닫은 적이 없다면 자동 열림
            setIsInquiryModalOpen(true);
            setShowFloatingBtn(false);
          }
        } else {
          setIsInquiryModalOpen(false);
          setShowFloatingBtn(true);
        }
      },
      { threshold: 0.1 },
    );

    const currentRef = sectionRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasClosedPopup]);

  // 팝업 닫기 핸들러
  const handleClosePopup = () => {
    setIsInquiryModalOpen(false);
    setShowFloatingBtn(true); // 팝업 닫으면 무조건 버튼 다시 표시
    setHasClosedPopup(true); // 팝업을 한 번 닫은 상태로 기록
  };

  const loadThumbs = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['110', '280', '285', '290'],
        pagePerCount: 8,
        category: ['A017'],
      });
      const articles = data as any;
      setThumbs(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            title: article.subject,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link:
              article.boardCategoryCode === '110'
                ? `/about-us/press/${article.boardIndexNumber}`
                : `/what-we-do/news/${article.boardIndexNumber}`,
            date: article.firstRegisterDate,
            boardCategoryCode: article.boardCategoryCode,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadThumbs();
  }, [loadThumbs]);

  useEffect(() => {
    if (hash && !hashScroll) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ block: 'start', behavior: 'instant' });
        hashScrollCallback(true);
      }
    }
  }, []);

  // useEffect(() => {
  //   setActiveTab(hash === '#sectionInquiryIC' ? 1 : 0);
  //   setHashScroll(false);
  // }, [hash]);
  // console.log('frame > hash : ', hash);

  const tab: { [key: number]: ReactElement } = {
    // 0번 탭은 이 페이지 자체이므로 아무 것도 넣지 않거나 null로 둡니다
    1: (
      <InternationalCouncilTab
        location={location}
        hashScroll={hashScroll}
        hashScrollCallback={(isScroll) => {
          setHashScroll(isScroll);
        }}
      />
    ),
  };

  return (
    <LayoutWithTitle
      // 강제로 breadcrumb 고정
      location={{
        ...location,
      }}
      paddingBtt
      title="고액·초고액후원"
      description="Unicef for every child"
    >
      <SectionTab>
        <Container>
          <ul className="flex">
            {honorTab.map(({ title, idx }) => (
              <TabButton
                ref={(ref) => {
                  if (activeTab === idx) {
                    targetRef.current = ref;
                  }
                }}
                active={activeTab === idx}
                key={idx}
                onClick={() => {
                  if (idx === 0) {
                    window.location.href = '/involve/individual/honors-club'; // 👉 0번 탭일 경우 현재 페이지 주소
                  } else if (idx === 1) {
                    window.location.href =
                      '/involve/individual/international-council'; // 👉 1번 탭일 경우 이동할 페이지
                  }
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </TabButton>
            ))}
          </ul>
        </Container>
      </SectionTab>
      <SectionTop className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="col-dec">
              <h2>
                <Tit size="s1">
                  <PageComponent id="title1">
                    가치가 가장 명예로운 모임, <br />
                    유니세프 아너스클럽
                  </PageComponent>
                </Tit>
              </h2>
              <p>
                <PageComponent id="content1">
                  유니세프 아너스클럽은 큰 나눔으로 세상의 변화를 이끄는
                  <br className="m-hide" />
                  후원자들의 모임으로 1억 원 이상 기부하신 회원들로 구성됩니다.
                  <br />
                  어린이를 돕는 가장 가치 있고 명예로운 모임!
                  <br />
                  유니세프 아너스클럽의 회원이 되어주세요.
                </PageComponent>
              </p>
            </div>
            <div className="col-img">
              <Image pcSrc={TopImg} mobileSrc={TopImgM} />
            </div>
          </SectionHeader>
        </Container>
      </SectionTop>

      <Container>
        <VideoContainer>
          <div className="video-wrap">
            <iframe
              className="video"
              src="https://www.youtube.com/embed/kPaOmQY01JY"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </VideoContainer>
      </Container>

      {/* 가입방법 */}
      <SectionJoin className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">유니세프 아너스클럽 가입방법</Tit>
            </h2>
          </SectionHeader>
          <ProcessList itemData={joinProcess} arrow link />
          <NotiBox className="FormGroup last">
            <NotiList>
              <NotiItem>
                일시후원 : 일시후원 또는 누적 후원금액이 1억 원 이상 개인후원자
              </NotiItem>
              <NotiItem>
                약정후원 : 3년 내 1억 원 이상 후원을 약정한 개인후원자
              </NotiItem>
            </NotiList>
          </NotiBox>
        </Container>
      </SectionJoin>

      <SectionHonorsClub>
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">아너스클럽 회원이 되시면</Tit>
            </h2>
          </SectionHeader>

          <ProcessList itemData={honorsclub} />
        </Container>
      </SectionHonorsClub>

      <SectionWidth className="by-sub-main-layout" ref={sectionRef}>
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">함께하는 분들</Tit>
            </h2>
          </SectionHeader>
          <SwiperPeople className="pc" overflowHidden>
            <Swiper
              slidesPerView="auto"
              navigation
              scrollbar={{ draggable: true }}
              className="scroll-only"
            >
              {peopleData.map((_, idx) => {
                if (idx % 9 === 0) {
                  return (
                    <SwiperSlide key={`peopleSwiper-pc-${idx}`}>
                      <ProcessList
                        itemData={peopleData.filter(
                          (_, idx2) => idx2 >= idx && idx2 < idx + 9,
                        )}
                        type="people"
                        justifyContent="start"
                        onItemClick={handleClick}
                      />
                    </SwiperSlide>
                  );
                }
              })}
            </Swiper>
          </SwiperPeople>
          <SwiperPeople className="mob">
            <Swiper
              slidesPerView="auto"
              scrollbar={{ draggable: true }}
              className="scroll-only"
            >
              {peopleData.map((_, idx) => {
                if (idx % 6 === 0) {
                  return (
                    <SwiperSlide key={`peopleSwiper-mo-${idx}`}>
                      <ProcessList
                        itemData={peopleData.filter(
                          (_, idx2) => idx2 >= idx && idx2 < idx + 6,
                        )}
                        type="people"
                        justifyContent="start"
                        onItemClick={handleClick}
                      />
                    </SwiperSlide>
                  );
                }
              })}
            </Swiper>
          </SwiperPeople>
          <p
            className="header-dec"
            css={`
              text-align: center;
            `}
          >
            기업인과 문화예술인, 스포츠선수 등 각 분야의 유명인사들이 참여하고
            있으며 이 밖에 일반 시민들도 큰 나눔으로 아너스클럽에 함께하고
            있습니다.
          </p>
        </Container>
      </SectionWidth>

      {isInquiryModalOpen && (
        <ContactPopup>
          <Modal
            maxWidth="480px"
            onRequestClose={() => {}}
            style={{ zIndex: `99` }}
          >
            <PopCcontainer>
              <PopupTitle>
                <h2>
                  <Tit size="s3" color="sky">
                    아너스클럽 문의
                  </Tit>
                </h2>
                <BtnClose onClick={handleClosePopup}>
                  <span className="a11y">닫기</span>
                </BtnClose>
              </PopupTitle>
              <PopupContent className="inquiry-pop-content">
                <H4>
                  맞춤 안내를 위해 <br />
                  궁금하신 점을 문의해주세요!
                </H4>
                <HonorsInquiryCard
                  formType="honors"
                  onComplete={(isComplete) => {
                    if (isComplete === true) setIsInquiryModalOpen(false);
                  }}
                />
              </PopupContent>
            </PopCcontainer>
          </Modal>
        </ContactPopup>
      )}

      {/* Modal 컴포넌트에 selectedPerson 전달 */}
      {isPeopleModalOpen && selectedPerson?.popImg && (
        <Modal maxWidth="880px">
          <PopCcontainer>
            <PopupTitle>
              <h2>
                <Tit size="s3" color="sky">
                  후원내역 / 활동
                </Tit>
              </h2>
              <BtnClose onClick={() => setIsPeopleModalOpen(false)}>
                <span className="a11y">닫기</span>
              </BtnClose>
            </PopupTitle>
            <PopupContent className="people-pop-content">
              {/* <div className="content-title">
                <Tit
                  size="s2"
                  dangerouslySetInnerHTML={{
                    __html: selectedPerson.desc[0].dec,
                  }}
                />
                {selectedPerson.pop.map((pop) => (
                  <p dangerouslySetInnerHTML={{ __html: pop.dec }} />
                ))}
              </div> */}
              <img src={selectedPerson.popImg} alt={selectedPerson.desc} />
            </PopupContent>
          </PopCcontainer>
        </Modal>
      )}

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex-middle">
              <h2>
                <Tit size="s1">최근 소식</Tit>
              </h2>
              <LinkSafe to="/what-we-do/news?category=A017" className="more">
                <span className="txt">더 보기</span>
              </LinkSafe>
            </div>
          </SectionHeader>
          {thumbs.length > 0 && (
            <RelativeBoardCard
              newslist={thumbs}
              isDate={false}
              isSwiper
              overflowHidden
            />
          )}
        </Container>
      </SectionNews>

      <BrochureWrap>
        <Container>
          <h4>
            <Tit size="s2">브로셔 다운로드</Tit>
          </h4>
          <div className="btn-wrap">
            {brochureData.map((row) => (
              <div className="col" key={row.id}>
                <Button
                  ico="down"
                  outline
                  full
                  onClick={() => window.open(row.link)}
                >
                  <span className="ico">{row.title}</span>
                </Button>
              </div>
            ))}
          </div>
        </Container>
      </BrochureWrap>

      <SectionInquiry id="sectionInquiry" className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">아너스클럽 문의</Tit>
            </h2>
          </SectionHeader>
          <HonorsInquiryCard formType="honors" onComplete={() => {}} />
        </Container>

        {showFloatingBtn && (
          <FloatingBtn
            onClick={() => {
              setIsInquiryModalOpen(true);
              setShowFloatingBtn(false); // 버튼 클릭 시 버튼 숨기기
            }}
          >
            아너스클럽
            <br className="br_pc" /> 문의하기
          </FloatingBtn>
        )}
      </SectionInquiry>

      <SectionContact className="by-sub-main-layout">
        <Container>
          <ContactUs itemData={contactData} />
        </Container>
      </SectionContact>
    </LayoutWithTitle>
  );
};

export default HonorsClub;
